import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_ACCOUNTING_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { BalanceTab } from "../components/BalanceTab"

const useStyles = makeStyles()((theme) => ({
    content: {
        width: "100%",
    },
}))

export function CashRegister() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="accounting-cash-register-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.ACCOUNTING_CASH_REGISTER}
                    title="Balance"
                    icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ACCOUNTING_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="merchant-nav-item-accounting">
                            <Breadcrumb>Accounting</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="accounting-cash-register-breadcrumb-title">
                            <Breadcrumb>Balance</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Box className={classes.content}>
                <BalanceTab />
            </Box>
        </>
    )
}
